import React, {Component} from "react";
import { GoogleLogin } from "react-google-login";
import CLIENT_ID from "../constants/googleClientID";

class GoogleLoginButton extends Component {
    constructor(props) {
        super(props);

        this.login = this.login.bind(this);
        this.handleLoginFailure = this.handleLoginFailure.bind(this);
    }

    login(response) {
        if(response.tokenId) {
            this.props.onGoogleLogin(response.tokenId);
        }
    }

    handleLoginFailure(response) {
        console.log(response);
        console.log("google login failed")
    }

    render() {
        return (
            <div>
                <GoogleLogin
                    onSuccess={ this.login }
                    onFailure={ this.handleLoginFailure }
                    clientId={ CLIENT_ID }
                />
            </div>
        );
    }
}

export default GoogleLoginButton;